var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { sdsCustomElement } from '../utilities/custom-components';
import styles from './sds-info-snippet.lit.scss';
/**
 * `sds-info-snippet` is a web component designed to display informative snippets with various types.
 * It allows users to present information clearly, using different visual cues based on the snippet type,
 * such as informational messages, warnings, or errors.
 *
 * ### Attributes
 * - `type`: The type of the info snippet, which can be 'info', 'warning', or 'error'. Defaults to 'info'.
 *
 * @tag sds-info-snippet
 */
let SdsInfoSnippet = (() => {
    var _SdsInfoSnippet_type_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-info-snippet')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    var SdsInfoSnippet = _classThis = class extends _classSuper {
        /**
         * Info snippet type.
         * This property determines the visual style and purpose of the snippet,
         * providing context to the user based on its type.
         *
         * Possible values:
         * - `info`: Displays general information.
         * - `warning`: Indicates a warning that requires attention.
         * - `error`: Represents an error message that needs to be addressed.
         *
         * Defaults to 'info'.
         *
         * @attr {InfoSnippetType} type - The type of the info snippet.
         */
        get type() { return __classPrivateFieldGet(this, _SdsInfoSnippet_type_accessor_storage, "f"); }
        set type(value) { __classPrivateFieldSet(this, _SdsInfoSnippet_type_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <sds-icon size="24" name="${this.getName()}" aria-hidden="true"></sds-icon>
                <slot></slot>
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-info-snippet': true,
                'sds-info-snippet--info': this.type === 'info',
                'sds-info-snippet--warning': this.type === 'warning',
                'sds-info-snippet--error': this.type === 'error',
            });
        }
        getName() {
            switch (this.type) {
                case 'info':
                    return 'information';
                case 'warning':
                    return 'warning';
                case 'error':
                    return 'warning_circle';
                default:
                    return '';
            }
        }
        constructor() {
            super(...arguments);
            _SdsInfoSnippet_type_accessor_storage.set(this, __runInitializers(this, _type_initializers, 'info'));
            __runInitializers(this, _type_extraInitializers);
        }
    };
    _SdsInfoSnippet_type_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInfoSnippet");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInfoSnippet = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInfoSnippet = _classThis;
})();
export { SdsInfoSnippet };
